import Home from "./pages/Home/Home";
import Projects from "./pages/Projects/Projects";
import Contact from "./pages/Contact/Contact";
import { NotFound } from "./pages/NotFound/NotFound";

const routes = [
  { path: "/", component: Home },
  { path: "/projects", component: Projects },
  { path: "/contact", component: Contact },
  { path: "*", component: NotFound },
];

export default routes;
